import { Box } from "@mui/material";
import { ReactNode } from "react";

interface DetailsPageLayoutProps {
  headerContent?: ReactNode;
  mainContent?: ReactNode;
}

export const DetailsPageLayout: React.FC<DetailsPageLayoutProps> = ({
  headerContent,
  mainContent,
}) => {
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
        maxWidth: "100%",
        maxHeight: "100%",
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ p: 2 }}>{headerContent}</Box>
      <Box
        sx={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          maxHeight: "100%",
          width: "100%",
        }}
      >
        {mainContent}
      </Box>
    </Box>
  );
};
